import script from "./AddComp.vue?vue&type=script&lang=ts&setup=true"
export * from "./AddComp.vue?vue&type=script&lang=ts&setup=true"

import "./AddComp.vue?vue&type=style&index=0&id=3f58944f&lang=scss&scoped=true"

import exportComponent from "/Users/ttheitao/Desktop/devApps/onetab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f58944f"]])

export default __exports__